module.exports = __webpack_public_path__ + "img/delete-icon.1db7bf15.svg";